/**
 * iurop-product-video.js — reproduce el vídeo del banner de producto (Glucody).
 * Clic en el póster → sustituye por el reproductor (YouTube/Vimeo/MP4) con autoplay.
 */
(function () {
  'use strict';

  function embedUrl(url) {
    var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{11})/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return null;
  }

  document.addEventListener('click', function (e) {
    var play = e.target.closest('[data-pvideo-play]');
    if (!play) return;
    var frame = play.closest('[data-pvideo]');
    if (!frame) return;
    var url = frame.getAttribute('data-video-url');

    if (url) {
      var embed = embedUrl(url);
      if (embed) {
        frame.innerHTML =
          '<iframe class="glucody-pvideo__embed" src="' + embed +
          '" title="Vídeo" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
      } else {
        // MP4 directo
        var v = document.createElement('video');
        v.className = 'glucody-pvideo__native';
        v.src = url;
        v.controls = true;
        v.autoplay = true;
        v.playsInline = true;
        frame.innerHTML = '';
        frame.appendChild(v);
      }
    }
  });
})();
